import { render, staticRenderFns } from "./trainingValidationTable.vue?vue&type=template&id=6dbc5ba6&scoped=true"
import script from "./trainingValidationTable.vue?vue&type=script&lang=js"
export * from "./trainingValidationTable.vue?vue&type=script&lang=js"
import style0 from "./trainingValidationTable.vue?vue&type=style&index=0&id=6dbc5ba6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbc5ba6",
  null
  
)

export default component.exports